<mat-form-field class="w-full custom-form budget-form-field" form>
  <input
    #budgetInput
    matInput
    mask="separator.2"
    class="budget-input"
    [dropSpecialCharacters]="true"
    [thousandSeparator]="thousandSeparator"
    [decimalMarker]="decimalSeparator"
    [disabled]="control().disabled"
    [matAutocomplete]="auto"
    [placeholder]="notDisclosedLabel()"
    (input)="onInputChange($any($event.target).value)"
  />

  @if (currencyIcon() && control().value) {
    <app-icon matPrefix [src]="currencyIcon()!" [alt]="currency()?.toString()!" class="w-4 h-4" />
  }

  <mat-autocomplete
    #auto="matAutocomplete"
    autoActiveFirstOption="true"
    [hideSingleSelectionIndicator]="true"
    (optionSelected)="onOptionSelected($event)"
  >
    @if (control().value) {
      <mat-option [value]="null" [class.mdc-list-item--selected]="control().value === null">
        {{ notDisclosedLabel() }}
      </mat-option>
    }

    @for (option of options; track option.toString()) {
      <mat-option [value]="option" [class.mdc-list-item--selected]="isOptionSelected(option)">{{ option }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
